import request from '@/utils/request'

// 登录方法
export function login(data) {
  return request({
    url: '/login',
    method: 'post',
    data
  })
}

// 登录方法
export function loginByAD() {
  return request({
    url: '/loginByAD/getAD',
    method: 'post',
  })
}

// 获取用户详细信息
export function getInfo() {
  return request({
    url: '/getInfo',
    method: 'get'
  })
}

// 退出方法
export function logout() {
  return request({
    url: '/logout',
    method: 'post'
  })
}

// 获取验证码
export function getCodeImg() {
  return request({
    url: '/getPic',
    method: 'get',
    headers: {'isToken': false},
  })
}

// 普通用户注册
export function register(data) {
  return request({
    url: '/userRegister',
    method: 'post',
    data
  })
}

// 忘记密码
export function forgetPassword(data) {
  return request({
    url: '/forgetSysUserPassword',
    method: 'post',
    data
  })
}

// 修改密码
export function updatePassword(data) {
  return request({
    url: '/updateSysUserPassword',
    method: 'post',
    data
  })
}

